import React, { useState, useContext } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Grid, Typography, Stack } from '@mui/material';
import appTheme from '../appTheme'
import { ThemeProvider } from '@mui/material/styles'
import EventContext from "../store/event-context";
import { displayCapnr} from "./helperFunctions";

const ParticipantIceModal = ({participant, close }) => {

    const [localParticipant, setLocalParticipant] = useState(participant);
    const changeNotAllowed = false;     // Changes only before registering
    const eventctx = useContext(EventContext);

    console.log("Calling ParticipantIceModal - participant: ", participant, " - localParticipant: ", localParticipant);

    if (participant.capnr !== localParticipant.capnr) {
        setLocalParticipant({
            ...localParticipant,
            'capnr': participant.capnr
        });
        //setIsWaiting(false);
    }

    const handleClose = () => {  close()  };

    return (
        <ThemeProvider theme={appTheme}>
        <div>
        <Dialog maxWidth='sm' fullWidth open={(participant.capnr.length > 0)} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
        <Stack direction='row' justifyContent='space-between' >
            <Typography align='left' component='span' variant='inherit'>Deelnemergegevens</Typography>
        </Stack>
        </DialogTitle>
        <DialogContent>
            <Box className='participantUpdateModal'>
                <Grid container columns={12}>
                    <Grid item id="Label00" xs={3}>Capnr.</Grid>
                    <Grid item xs={9}>
                        {displayCapnr(localParticipant.capnr, eventctx.event.colors)}
                    </Grid>
                    <Grid item id="Label01" xs={3}>Voornaam</Grid>
                    <Grid item xs={9}>
                        {localParticipant.firstName}
                    </Grid>
                    <Grid item id="Label02" xs={3} >Achternaam</Grid><Grid item xs={9}>
                        {localParticipant.lastName}
                    </Grid>
                    <Grid item id="Label03" xs={3}>Postcode</Grid><Grid item xs={4}>
                        {localParticipant.zipcode}
                    </Grid>
                    <Grid item id="Label04" xs={2}>
                        <Typography textAlign='right' >Huisnr: </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        {localParticipant.houseNumber}
                    </Grid>
                    <Grid item id="Label05" xs={3} >Afstand</Grid>
                    <Grid item xs={9} >
                        {localParticipant.distance}
                    </Grid>
                    <Grid item id="Label06" xs={3}>Geboortedatum</Grid>
                    <Grid item id="Input-Date" xs={9} >
                        {localParticipant.birthday}
                    </Grid>
                    <Grid item id="Label07" xs={3}>Team</Grid>
                    <Grid item xs={9}>
                        {localParticipant.teamName}
                    </Grid>
                    <Grid item id="Label08" xs={3}>Wave</Grid>
                    <Grid item xs={9}>
                        {localParticipant.wave}
                    </Grid>
                    <Grid item id="Label09" xs={3}>Email</Grid>
                    <Grid item xs={9}>
                        {localParticipant.email}
                    </Grid>
                    <Grid item id="Label10" xs={3}>Telefoonnummer</Grid>
                    <Grid item xs={9}>
                        {localParticipant.phone}
                    </Grid>
                    <Grid item xs={12} sx={{ paddingTop: 2, paddingY: -2, fontWeight: 'bolder', fontSize: 22 }} >
                    Contactgegevens in geval van nood</Grid>
                    <Grid item id="Label11" xs={3} sx={{paddingLeft: 2, fontSize: 16}} >Voornaam</Grid>
                    <Grid item xs={9} sx={{fontWeight: 'bold', fontSize: 18}} >
                        {localParticipant.iceFirstName}
                    </Grid>
                    <Grid item id="Label12" xs={3} sx={{paddingLeft: 2, fontSize: 16  }}>Achternaam</Grid>
                    <Grid item xs={9} sx={{fontWeight: 'bold', fontSize: 18}}>
                        {localParticipant.iceLastName}
                    </Grid>
                    <Grid item id="Label13" xs={3} sx={{paddingLeft: 2, fontSize: 16 }}>Telefoon 1</Grid>
                    <Grid item xs={3} sx={{fontWeight: 'bold', fontSize: 18}}>
                        {localParticipant.icePhone1}
                    </Grid>
                    <Grid item id="Label14" xs={3} sx={{paddingRight: 1, fontSize: 16 }}>Telefoon 2</Grid>
                    <Grid item xs={3} sx={{fontWeight: 'bold', fontSize: 18}}>
                        {localParticipant.icePhone2}
                    </Grid>
                </Grid>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button 
                variant="outlined"
                onClick={handleClose}
                color="secondary"
                sx={{ textTransform: 'capitalize', width: '116px' }}>
            {'Sluiten' }
            </Button>
        </DialogActions>
        </Dialog>
        </div>
        </ThemeProvider>
    )
}

export default ParticipantIceModal
